import React from 'react';
import { Check } from 'lucide-react';
const reasons = ['User-friendly platform designed for non-techies', 'Arizona-based instruction relevant to your market', 'Broker-led education with real-world examples', 'Instant reporting to ADRE upon completion', 'Friendly local support team available by phone', 'Competitive pricing with no hidden fees'];
export function WhyDesertSage() {
  return <section className="py-20 bg-white" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-204">
          <div className="mb-12 lg:mb-0" data-id="element-205">
            <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl mb-6" data-id="element-206">
              Why Arizona Agents Choose{' '}
              <span className="text-brand-purple-600" data-id="element-207">Desert Sage</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-208">
              We understand that license renewal can be stressful. That's why
              we've built our entire platform around simplicity, compliance, and
              local expertise. We aren't a big national chain—we're Arizona real
              estate experts helping our peers succeed.
            </p>

            <ul className="space-y-4" data-id="element-209">
              {reasons.map((reason, index) => <li key={index} className="flex items-start" data-id="element-210">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-green-100 flex items-center justify-center mt-0.5" data-id="element-211">
                    <Check className="w-4 h-4 text-green-600" data-id="element-212" />
                  </div>
                  <span className="ml-3 text-gray-700 font-medium" data-id="element-213">
                    {reason}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="relative" data-id="element-214">
            <div className="absolute inset-0 bg-gradient-to-tr from-brand-purple-200 to-brand-orange-100 rounded-2xl transform rotate-3 scale-105 opacity-50" data-id="element-215" />
            <div className="relative bg-gray-50 rounded-2xl p-8 border border-gray-100 shadow-lg" data-id="element-216">
              <div className="flex items-center space-x-4 mb-6" data-id="element-217">
                <div className="w-12 h-12 bg-brand-purple-600 rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-218">
                  DS
                </div>
                <div data-id="element-219">
                  <h3 className="font-bold text-gray-900" data-id="element-220">
                    Desert Sage Seminars
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-221">Established 2006</p>
                </div>
              </div>
              <p className="text-gray-600 italic mb-6" data-id="element-222">
                "Our mission is to provide high-quality, relevant education that
                makes the renewal process as painless as possible for Arizona
                real estate professionals."
              </p>
              <div className="flex items-center justify-between text-sm font-medium text-gray-500 border-t pt-4" data-id="element-223">
                <span data-id="element-224">ADRE School #S06-0002</span>
                <span data-id="element-225">Phoenix, AZ</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}